import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Payment history list
  payments: [],
  isLoading: false,
  error: false,

  // Stripe: create Checkout Session
  checkoutLoading: false,
  checkoutError: null,

  // Stripe: verify session after redirect back
  verifyLoading: false,
  verifySuccess: false,
  verifyError: null,
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,

  reducers: {
    // ── Payment history ──────────────────────────────────────────────────────
    getPaymentsLoading: (state) => {
      state.isLoading = true;
      state.error = false;
    },
    getPaymentsSuccess: (state, { payload }) => {
      state.payments = payload;
      state.isLoading = false;
      state.error = false;
    },
    getPaymentsFailed: (state) => {
      state.isLoading = false;
      state.error = true;
    },

    // ── Stripe: create Checkout Session ──────────────────────────────────────
    checkoutLoading: (state) => {
      state.checkoutLoading = true;
      state.checkoutError = null;
    },
    checkoutFailed: (state, { payload }) => {
      state.checkoutLoading = false;
      state.checkoutError = payload;
    },
    // No checkoutSuccess reducer needed — on success we immediately redirect
    // the browser to Stripe's hosted page (window.location.href), so there
    // is no state to store on the frontend.
    checkoutRedirecting: (state) => {
      state.checkoutLoading = false;
    },

    // ── Stripe: verify session after redirect back ────────────────────────────
    verifyLoading: (state) => {
      state.verifyLoading = true;
      state.verifySuccess = false;
      state.verifyError = null;
    },
    verifySuccess: (state) => {
      state.verifyLoading = false;
      state.verifySuccess = true;
      state.verifyError = null;
    },
    verifyFailed: (state, { payload }) => {
      state.verifyLoading = false;
      state.verifySuccess = false;
      state.verifyError = payload;
    },
  },
});

export const {
  getPaymentsLoading,
  getPaymentsSuccess,
  getPaymentsFailed,
  checkoutLoading,
  checkoutFailed,
  checkoutRedirecting,
  verifyLoading,
  verifySuccess,
  verifyFailed,
} = paymentSlice.actions;

export default paymentSlice.reducer;
